import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from 'src/app/services/shared.service';
import { HeaderPagesService } from '../header-pages.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  URl: any;
  isFromLogin = false;

  constructor(
    private dialogRef: MatDialogRef<PrivacyPolicyComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private sanitizer: DomSanitizer,
    public sharedService: SharedService,
    private headerPagesService: HeaderPagesService,
  ) { }

  ngOnInit(): void {
    this.setUrl();
    if (this.data && this.data.isFromLogin) {
      this.isFromLogin = this.data.isFromLogin;
    }
  }

  setUrl() {
    this.URl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
  }

  saveClick() {
    this.headerPagesService.licenseAccepted(this.data.userId).subscribe((res: any) => {
      if (res) {
        this.dialogRef.close(true);
      }
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
